/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
//= require v4/file_uploads
//= require ../markdown_editor
const AgGridMarkdownHelpers = require('../communicate_decision/ag_grid_markdown_helpers');

window.DocumentSetsIssues = {
  _renderIssueTitle(params) {
    return `<a class ='bold-weight' target='_blank' href=\"${params.data.url}\">${params.data.title}</a>`;
  },

  _renderIssueDescription(params) {
    return `\
<div class='markdown' id='${params.data.id}' style='overflow: auto;'>
  ${MarkdownEditor.renderMarkdownAsHTML(params.data.description)}
</div>\
`;
  },

  _renderIssueSeverity(params) {
    return `<div class='issue-severity ${params.data.severity}'>${params.data.severity}</div>`;
  },

  _renderDocumentVersionSeq(params) {
    return `V${params.data.from}`;
  },

  _renderIssueReference(params, project_ref) {
    return `${project_ref}-no${params.data.number}`;
  },

  _renderCategoryPath(categories, params) {
    const category = _.where(categories, { id: params.data.type_category_id })[0];
    if (!category) { return "-"; }
    const parentTitles = _.clone(category.parent_titles);
    const path = parentTitles.reverse().join(' > ');
    return `<span class='no-wrap'>${path}</span>`;
  },

  initializeDocumentIssuesGrid(tableSelector, params, categories, project_ref) {
    const data = _.map(params, doc => JSON.parse(doc));

    const columnDefs =
      [
        { headerName: I18n.t('v4.issues.issue'), field: 'title', cellClass: 'description', width: 150, cellRenderer: issue => this._renderIssueTitle(issue) },
        { headerName: I18n.t('description'), field: 'description', autoHeight: true, width: 330, cellClass: 'description', cellRenderer: issue => this._renderIssueDescription(issue) },
        { headerName: I18n.t('category'), field: 'category_path', cellRenderer: issue => this._renderCategoryPath(categories, issue) },
        { headerName: I18n.t('reference'), field: 'number', width: 60, cellRenderer: issue => this._renderIssueReference(issue, project_ref) },
        { headerName: I18n.t('v4.issues.grids.headers.reported_by'), field: 'creator', autoHeight: true, width: 120 },
        { headerName: I18n.t('v4.issues.grids.headers.reported_in'), field: 'from', width: 70, cellRenderer: issue => this._renderDocumentVersionSeq(issue) },
        { headerName: I18n.t('v4.issues.severity.placeholder'), field: 'severity', width: 90, cellRenderer: issue => this._renderIssueSeverity(issue) },
        { headerName: I18n.t('status'), field: 'status', width: 95, suppressSizeToFit: true, cellRenderer: issue => escapeHTML(issue.data.partial) }
      ];

    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      columnDefs,
      rowData: data,
      domLayout: 'autoHeight',
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressHeaderMenuButton: true
      },
      getRowId(params) { return String(params.data.id); },
      onGridReady(event) {
        return event.api.sizeColumnsToFit();
      },
      onGridSizeChanged(event) {
        return AgGridMarkdownHelpers.resizeTable({ tableId: tableSelector, gridApi: event.api, headerHeight: this.headerHeight });
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi;
    AgGridMarkdownHelpers.resizeTable({ tableId: tableSelector, gridApi: gridApi, headerHeight: gridOptions.headerHeight });

    const $issuesTable = $(`#${tableSelector}`);
    return $issuesTable.closest('.issue').find('.toggle-content').on('click', event => {
      const $issue = $(event.currentTarget);
      $issue.closest('.item-expandable').toggleClass('expanded');
      gridApi.sizeColumnsToFit();
      return $issuesTable.siblings('.issues-states').remove();
    });
  },

  _renderNotesButton(params) {
    return `<a id='notes-doc-${params.data.id}' class='button nano icon-btn pt-edit' href='#'></a>`;
  },

  _renderIssueReportedIn(params) {
    return `V${params.data.from}`;
  },

  _renderIssueCheckbox(params) {
    const select = document.createElement("select");
    select.id = `document_version_issue_stat_${params.data.id}`;
    select.className = 'select required';
    select.name = `document[issues][${params.data.id}][state]`;
    select.setAttribute('include_blank', '');
    select.setAttribute('aria-required', 'true');
    select.setAttribute('required', 'required');

    const options = [['', 'Select'], ['fixed', 'Fixed'], ['open', 'Not Fixed'], ['invalid', 'Invalid']];

    for (let option_values of Array.from(options)) {
      const option = document.createElement("option");
      option.value = option_values[0];
      option.text = option_values[1];

      if (option.text === 'Select') { option.selected = 'selected'; }

      select.appendChild(option);
    }

    $(select).on('change', function (e) {
      if (($(this).val() === 'open') || ($(this).val() === 'invalid')) {
        if ($(this).closest('.ag-row').find('.ag-group-expanded').hasClass('ag-hidden')) {
          $(this).closest('.ag-row').find('.ag-group-contracted').click();
        }
        $(`#document-issue-${params.data.id}-clarification`).attr('required', true);
      }

      if ($(this).val() === 'fixed') {
        if ($(this).closest('.ag-row').find('.ag-group-contracted').hasClass('ag-hidden')) {
          $(this).closest('.ag-row').find('.ag-group-expanded').click();
        }
        return $(`#document-issue-${params.data.id}-clarification`).attr('required', false);
      }
    });

    const selectWrapper = document.createElement('div');
    const errorMessage = document.createElement('small');
    errorMessage.className = 'error';
    errorMessage.innerHTML = I18n.t('required');
    $(selectWrapper).append(select);
    $(selectWrapper).append(errorMessage);
    return selectWrapper;
  },

  initializeRejectedDocumentIssuesGrid(tableSelector, params, project_ref, param) {
    if (param == null) { param = {}; }
    let { modal } = param;
    if (modal == null) { modal = false; }

    const data = _.map(params, doc => JSON.parse(doc));

    const titleWidth = modal ? 400 : 600;
    const columnDefs =
      [
        { headerName: I18n.t('v4.issues.grids.headers.ref_no'), field: 'number', width: 90, cellRenderer: issue => this._renderIssueReference(issue, project_ref) },
        { headerName: I18n.t('v4.issues.grids.headers.title_and_description'), field: 'description', autoHeight: true, width: titleWidth, cellClass: 'description', cellRenderer: issue => this._renderIssueDescription(issue) },
        { headerName: I18n.t('v4.issues.grids.headers.page'), field: 'page', width: 40 },
        { headerName: I18n.t('v4.issues.grids.headers.reported_in'), field: 'from', width: 90, autoHeight: true, cellRenderer: issue => this._renderIssueReportedIn(issue) },
        { headerName: I18n.t('v4.issues.severity.placeholder'), field: 'severity', width: 100, cellRenderer: issue => this._renderIssueSeverity(issue) },
        { headerName: I18n.t('status'), field: 'status', width: 110, cellRenderer: issue => this._renderIssueCheckbox(issue) },
        { headerName: I18n.t('v4.issues.grids.headers.notes'), field: 'details', width: 60, cellRenderer: 'agGroupCellRenderer', cellRendererParams: issue => ({ innerRenderer: this._renderIssueSeverity(issue) }) }
      ];

    const FullWidthCellRenderer = function () { };

    FullWidthCellRenderer.prototype.init = function (params) {
      const eTemp = document.createElement('div');
      eTemp.innerHTML = this.getTemplate(params);
      this.eGui = eTemp.firstElementChild;
    };

    FullWidthCellRenderer.prototype.getTemplate = params => `<div class='row-padding markdown-textarea'>
<textarea id='document-issue-${params.data.id}-clarification' name='document[issues][${params.data.id}][clarification]' placeholder='${I18n.t('v4.issues.grids.clarifications.placeholder')}'></textarea>
<small class='error'>` + I18n.t('required') + `</small>
</div>`;

    FullWidthCellRenderer.prototype.getGui = function () {
      return this.eGui;
    };


    const gridOptions = {
      paginationPageSize: 10,
      headerHeight: 44,
      rowHeight: 80,
      rowStyle: { overflow: 'hidden' },
      columnDefs,
      rowData: data,
      fullWidthCellRenderer: FullWidthCellRenderer,
      defaultColDef: {
        resizable: true,
        suppressHeaderMenuButton: true
      },
      isFullWidthRow(params) {
        return params.rowNode.data != null;
      },
      onGridSizeChanged(event) {
        return event.api.sizeColumnsToFit();
      }
    };

    const gridDiv = document.getElementById(tableSelector);
    const gridApi2 = agGrid.createGrid(gridDiv, gridOptions);
    gridOptions.api = gridApi2;
    resizeAgGridTable(`#${tableSelector}`, gridOptions);
    gridApi2.sizeColumnsToFit();

    $(`#${tableSelector}`).on('click', '.ag-group-contracted', () => $(`#${tableSelector}`).css('height', $(`#${tableSelector}`).height() + 80));

    return $(`#${tableSelector}`).on('click', '.ag-group-expanded', () => $(`#${tableSelector}`).css('height', $(`#${tableSelector}`).height() - 80));
  }
};
